export const landing = {
  bannerTextBig: 'HANDWERKER-OFFERTEN FÜR IHR <br />SANIERUNGSPROJEKT',
  bannerTextBigMobile: 'OFFERTEN FÜR IHR PROJEKT',
  bannerTextSmall:
    'Erhalten Sie kostenlos bis zu drei Offerten von geprüften Qualitätsbetrieben aus Ihrer Region mit HausHeld.ch',
  bannerTextBelowButton: 'völlig unverbindlich und ohne versteckte Kosten!',
  section2TextBig: 'Ganz einfach zu Offerten von Ihren lokalen Handwerker-Helden',
  section2TextMedium:
    'Auf HausHeld.ch können Sie die Bedürfnisse für Ihr Umbauprojekt effizient und einfach schildern und erhalten gratis Vergleichsofferten.',
  section2TextSmall:
    'Kostenfrei werden Ihnen von HausHeld geprüfte Anbieter vermittelt, die am besten zu Ihrem Projekt passen. So erhalten Sie bis zu drei professionelle Beratungen und Offerten von Schweizer Fachbetrieben aus Ihrer Region.',
  section4TextBig: 'Wunschhandwerker finden – so einfach geht’s:',
  section4Block1Title: '1. Renovationsprojekt erfassen',
  section4Block1Text:
    'Schritt-für-Schritt nehmen wir die wichtigsten Datenpunkte für Ihr Projekt auf - um Ihnen zu helfen.',
  section4Block2Title: '2. Handwerkervorschläge aus der Region bekommen',
  section4Block2Text:
    'Mittels unserer Matching-Technologie finden wir passende Handwerker aus Ihrer Region und stellen einen unverbindlichen Kontakt her.',
  section4Block3Title: '3. Kostenlos unverbindliche Offerten erhalten',
  section4Block3Text:
    'Die Fachpartner beraten Sie und übermitteln Ihnen kostenlos und unverbindlich Offerten. Wenn es für Sie passt - können Sie Ihren Wunschhelden auswählen.',
  section5Title: 'HausHeld-Vorteile',
  section5Block1Title: 'Bis zu 30 % sparen',
  section5Block1Text:
    'HausHeld schafft ein faires Wettbewerbsumfeld für Anbieter, sodass Sie als Kunde nur optimale Angebote erhalten.',
  section5Block2Title: 'Zeit und Mühe sparen',
  section5Block2Text:
    'Wir übernehmen die Suche nach vertrauensvollen Handwerkern und vermitteln Ihnen effizient und einfach den Kontakt.',
  section5Block3Title: 'Perfekt passende Haushelden',
  section5Block3Text:
    'HausHeld-Anbieter stehen nicht nur für Qualität und Zuverlässigkeit – Sie bringen immer genau die Stärken, die Ihr Individuelles Projekt benötigt.',
  section6Title: 'Das HausHeld-Versprechen',
  section6Text1:
    'Als Schweizer Renovationsportal mit Sitz in Herisau (AR) vermittelt Ihnen HausHeld Qualitäts-Handwerker aus Ihrer Region – überall in der gesamten Schweiz. Ob in Kontakt mit unseren geprüften Handwerker-Helden oder mit HausHeld Mitarbeitern',
  section6Text2: '– Servicequalität steht an erster Stelle.',
  section6Block1Top: 'Über',
  section6Block1Middle: '125’000',
  section6Block1Bottom: 'Erfolgreiche <br />Vermittlungen',
  section6Block2Top: 'Mehr als',
  section6Block2Middle: '20',
  section6Block2Bottom: 'Schweizer <br />Branchen',
  section6Block3Top: 'Über',
  section6Block3Middle: '950',
  section6Block3Bottom: 'Aktive <br />Handwerkspartner',
  section6Block4Top: 'Bereits mehr als',
  section6Block4Middle: '900 Mio.',
  section6Block4Bottom: 'CHF generiertes Projektvolumen',
  section7Title: 'Wählen Sie Ihr Projekt',
  section7ButtonText: 'Weitere Branchen',
  section8TextBig: 'Projekte, Finanzen & Analysen – Heldenhaft einfach für Ihr ganzes Zuhause',
  section8TextSmall:
    'Zum optimalen Zeitpunkt helfen wir Ihnen dabei die Sanierungskosten für Ihre Liegenschaft zu berechnen. Dabei stehen natürlich wichtige Elemente wie die Energie-Effizienz oder die Steuerbelastungen ebenso im Fokus wie eine ganzheitliche Übersicht der Finanz rund ums Haus. Sparen Sie sich Zeit, Geld und Nerven mit der heldenhaften Unterstützung ihres persönlichen digitalen Hausverwaltungstools.',
  section8ButtonText: 'Los geht’s',
  section9Title: 'Das sagen unsere Kunden',
  section9Testimonial1Text:
    'Die Anfrage war rasch erstellt. In nur kurzer Zeit hatten wir telefonischen Kontakt zu HausHeld, um die Anfrage zu bestätigen und Details zu besprechen. Drei interessierte Handwerker meldeten sich! Unsere Anfrage wurde nach einer Besichtigung zu einem fairen Preis gelöst. HausHeld hat super vermittelt, wir waren sehr zufrieden.',
  section9Testimonial1Name: 'Dorothea M.',
  section9Testimonial1Year: '2021',
  section9Testimonial2Text:
    'Nach der Anfrage wurde ich dem Hausheld-Team bzgl. Details angerufen. Anschliessend wurden mir sehr passende regionale Firmen vermittelt. Das Portal hat mir die Suche sehr erleichtert. Würde es jeder Zeit weiterempfehlen!',
  section9Testimonial2Name: 'Urs S.',
  section9Testimonial2Year: '2021',
  section10Title: 'OFFERTEN FÜR IHR <br />SANIERUNGSPROJEKT',
  section10Text:
    'Über HausHeld bekommen Sie kostenlos bis zu drei Vergleichsofferten <br />von geprüften Handwerkern aus Ihrer Region',
  section10ButtonText: 'Jetzt Projekt starten',
  section10SmallTextBelowButton: 'völlig unverbindlich und ohne versteckte Kosten!',
  brokerTitle: 'Beachten Sie beim Verkauf unbedingt folgende Punkte:',
  brokerTitle1: 'Kaufpreis',
  brokerText1:
    'Eine professionelle Bewertung der Immobilie lohnt sich. Wird der Preis zu tief angesetzt, entgeht Ihnen womöglich viel Geld. Ist der Preis zu hoch, entgehen Ihnen Anfragen und im schlimmsten Fall steht Ihre Immobilie lange leer.',
  brokerTitle2: 'Zielgruppe',
  brokerText2:
    'Stellen Sie sich die Frage, wer Interesse an der Immobilie haben könnte und wie diese Zielgruppe erreicht werden kann. So können Sie zusammen mit Ihrem Makler die beste Strategie entwickeln.',
  brokerTitle3: 'Präsentation',
  brokerText3:
    'Um Ihre Immobilie bestmöglich zu präsentieren und potenziellen Käufern Einsicht in das Objekt zu geben, wird ein Exposee erstellt. Darin enthalten sind hochwertige Fotos der Immobilie und weitere Unterlagen wie Grundrisspläne, Lagepläne, Baugenehmigungen und Grundbuchauszüge. Im Idealfall erstellen Sie zwei verschiedene Exposees: Ein Kurzes, welches nicht mehr als 3 Seiten umfasst und die wichtigsten Bilder und Übersichten enthält und eine ausführliche Version, welche potenziellen Käufern bei Interesse gesendet werden kann.',
  brokerTitle4: 'Warum sich ein Makler lohnt',
  brokerText4:
    'Ein Immobilienverkauf ist oft mit zeitlichem Aufwand verbunden. Makler sind jederzeit erreichbar und bieten die Flexibilität, dass Objekt potenziellen Käufern jederzeit zu zeigen. Ebenfalls besitzen sie wichtige Kenntnisse in Sachen Bewertung und Verkauf und können Ihnen beispielsweise beim Aufsetzen des Vertrages behilflich sein.',
  brokerTitle5: 'Warum sich ein Maklervergleich lohnt',
  brokerText5:
    'Die Makler verlangen für einen erfolgreichen Verkauf eine Provision, die oft vom Verkaufswert abhängig ist. Vergleichen Sie jetzt Makler in Ihrer Region und erhalten Sie bis zu 3 Offerten und Beratungen kostenlos und unverbindlich.',
}

export const noMatchingProject = {
  title: 'Kein passendes Projekt dabei?',
  text: 'Sie haben nichts passendes für Ihr Projekt gefunden?<br /> Schlagen Sie uns jetzt ganz einfach Ihr Wunschgewerk vor.',
  desiredCraft: 'Wunschgewerk',
  checkboxLabel:
    'Ja, ich bin einverstanden, in Zukunft über weitere Dienstleistungen informiert zu werden.',
  proposeCraftButtonText: 'Gewerk vorschlagen',
  successText: 'Ihr Wunschgewerk wurde uns erfolgreich mitgeteilt.',
}

export const projectOverview = {
  title: 'Projektübersicht',
}
